import React from 'react'
import {
  Box,
  Spinner,
  Center,
  Heading,

} from '@chakra-ui/react'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

import DataTable from '../components/AllDataTable'
import { dataService } from '../services/api'
import { capitalize } from '../utils/helpers'

const DataPage: React.FC = () => {
  const param = useParams()

  // Get recordType from URL or default to 'Data'
  const recordType = param.type || 'Data'

  const { data, isLoading, error } = useQuery({
    queryKey: ['dataRecords', recordType],
    queryFn: async () => {
      // @ts-ignore
      const response = await dataService.getAllDataRecords(recordType)
      return response.data || []
    },
    select: (data) => {
      return [...data].sort((a, b) => 
        new Date(b.record.last_updated).getTime() - new Date(a.record.last_updated).getTime()
      )
    }
  })

  return (
    <Box p={4}>
      {isLoading && !data ? (
        <Center h="60vh">
          <Spinner size="xl" color="blue.500" />
        </Center>
      ) : (
        <>
          <Heading size="lg" mb={6}>
            {capitalize(recordType)} Records
          </Heading>

          <DataTable
            showUserId
            data={data || []}
            isLoading={isLoading}
            error={error}
            // @ts-ignore
            recordType={recordType}
          />
        </>
      )}
    </Box>
  )
}

export default DataPage
